// extracted by mini-css-extract-plugin
module.exports = {"touch-ripple":"styles_touch-ripple__3rrwc","expandIcon":"styles_expandIcon__2nUAz","collapseIcon":"styles_collapseIcon__1fmXz","expansion-panel":"styles_expansion-panel__2KXNR"};